import styled, { css } from 'styled-components';
import { StackedCompanyUserList } from 'src/components/domain/users/components/stacked-company-user-list';
import { LggUserAvatar } from 'src/components/general/display/user-avatar';
import { Icon } from 'src/components/general/icon';

const avatarStyles = css`
  border: 1px solid ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.font.regular};
  font-size: 10px;
  height: 18px;
  letter-spacing: -0.667px;
  line-height: 11px;
  width: 18px;
`;

export const StyledStackedCompanyUserList = styled(StackedCompanyUserList)`
  .stacked-list-item {
    ${avatarStyles};
    text-align: center;

    &.list-extra-item-count {
      border: 1px solid ${({ theme }) => theme.colors.casper};
      height: 20px;
      margin-top: 0;
      width: 20px;
    }

    &:not(:first-child) {
      margin-left: -13px;
    }
  }
`;

export const UnassignedPrefixIcon = styled(Icon)`
  align-items: center;
  background: ${({ theme }) => theme.colors.white};
  border-radius: 50%;
  border: 1px solid ${({ theme }) => theme.colors.casper};
  display: flex;
  height: 20px;
  justify-content: center;
  padding: 2px;
  width: 20px;

  svg {
    height: 12px;
    width: 14px;

    path {
      fill: ${({ theme }) => theme.colors.flint};
    }
  }
`;

export const OnlyMeAvatar = styled(LggUserAvatar)`
  ${avatarStyles};
`;
